<template>
	<div>
		<Button type="info" @click="add">添加</Button>
		<Divider />
		
		<!-- 内容-->
		<div class="content">
			<div class="content-left">
				<ul class="content-left-ul">
					<li @click="showItem(index)" :class="docInfo.uuid == item.uuid ? 'content-left-ul-li content-left-ul-li-active' : 'content-left-ul-li'" v-for="(item,index) in docData" :key="index">
						{{item.title}}
					</li>
				</ul>
			</div>
			<div class="content-right">
				<Scroll  :height="600">
			        <div  class="content-html" v-html="docInfo.content"></div>
			    </Scroll>
				
				<!-- 操作-->
				<div class="do-content" v-show="docInfo.uuid">
					<Button type="primary" @click="update" size='small' style="margin-right: 8px;">编辑</Button>
					<Button type="error" @click="doDelete" size='small'>删除</Button>
				</div>
			</div>
		</div>
		
		<!-- 添加modal -->
		<Modal
			width="1000"
	        v-model="show"
	        title="文档信息"
	        @on-cancel="show = false;"
	        :mask-closable="false">
	        <Form  :label-width="100" :model="formData" ref="formData" :rules="formDataRules">
	        	<FormItem label="文档名称：" prop="title">
		            <Input style="width: 600px;" v-model="formData.title" placeholder="请输入文档名称"></Input>
		        </FormItem>
		        <FormItem label="标签：">
		            <Input style="width: 600px;" v-model="formData.tag" placeholder="请输入文档标签"></Input>
		        </FormItem>
	        </Form>
	        <editor v-if="show" :html="formData.content" @send-html="getHtml"></editor>
	        <div slot="footer">
	        	<Button type="default" @click="show = false;">取消</Button>
	        	<Button type="primary" @click.prevent="submit">提交</Button>
	        </div>
	    </Modal>
	</div>
</template>

<script>
import Editor from '@/components/Editor'
import {addDoc,updateDoc,getDoc,deleteDoc} from '@/utils/api.js'
export default{
	name:'Mysql',
	components: { 
		Editor
	},
	data(){
		return {
			show:false,
			formData:{
				uuid:'',
				title:'',
				tag:'',
				content:''
			},
			formDataRules:{
				title: [{ required: true, message: '请输入文档标题', trigger: 'blur',type:'string' }]
			},
			docData:[],
			docInfo:{}
		}
	},
	methods:{
		add(){
			this.show = true;
			
			this.$refs['formData'].resetFields();
			 
			this.formData.content = '';
			this.formData.title = '';
			this.formData.tag = '';
			this.formData.uuid = '';			
		},
		update(){
			this.show = true;
			
			this.$refs['formData'].resetFields();
			 
			this.formData = {...this.docInfo};
		},
		submit(){
			this.$refs['formData'].validate((valid)=>{
				
				if(valid){
					let param = {
						title:this.formData.title,
						content:this.formData.content,
						tag:this.formData.tag
					}
					
					if(this.formData.uuid){
						param.uuid = this.formData.uuid;
						
						updateDoc({form:param}).then(res=>{
							let index = null;
							this.docData.forEach((e,key)=>{
								if(e.uuid == res.uuid){
									index = key;
								}
							})
							
							if(index !== null){
								this.docData[index] = {...this.docData[index],...res};
								this.docInfo = {...this.docData[index]};
							}
							
							this.$Message.info('编辑成功');
							this.show = false;
						})
					}else{
						param.type = 3;
						addDoc({form:param}).then(res=>{
							this.docData.push(res);
							this.$Message.info('添加成功');
							this.show = false;
						})
					}
				}
			})
		},
		doDelete(){
			let that = this;
			
			this.$Modal.confirm({
				title:'删除确认',
				content:'该操作不可逆，是否确认删除？',
				onOk:function(){
					deleteDoc({uuid:that.docInfo.uuid}).then(res=>{
						let index = null;
						that.docData.forEach((e,key)=>{
							if(e.uuid == res){
								index = key;
							}
						})
						
						if(index !== null) that.docData.splice(index,1);
						that.docInfo = {...{}};
					})
				}
			})
		},
		getHtml(html){
			this.formData.content = html;
		},
		async getDocList(){
			let data = await getDoc({type:3});
			this.docData = data;
			
			//渲染第一条
			if(data.length > 0){
				this.docInfo = {...data[0]};
			}
		},
		showItem(index){
			this.docInfo = {...this.docData[index]};
		}
	},
	mounted(){
		this.getDocList();
	},
	beforeDestroy() {
      
    },
   	watch:{
   		'docInfo.uuid':function(){
   			if(this.docInfo.uuid === undefined || !this.docInfo.uuid){
   				if(this.docData.length > 0) this.docInfo = {...this.docData[0]};
   			}
   			
   		}
   	}
}
</script>

<style scoped>
.content{
	width: 1200px;
	height: 600px;	
	display: flex;
	justify-content: center;
}
.content-left{
	width: 210px;
	height: 600px;
	position: relative;
	background: #f1f1f1;
}
.content-right{
	width: 1000px;
	height: 600px;
	position: relative;
	background: #384548;
	overflow: hidden;
}
.content-left-ul{
	width: 200px;
	height: 600px;
	overflow-y: scroll;
	padding: 5px;
	overflow-x: hidden;
}
.content-left-ul-li{
	width: 180px;
	height: 40px;
	cursor: pointer;
	white-space: nowrap;
	line-height: 40px;
	padding: 0 10px;
	overflow: hidden;
	transition: all 0.5s;
	text-overflow: ellipsis;
	color: #606266;
	font-size: 16px;
	display: flex;
	align-items: center;
	box-sizing: border-box;
}
.content-left-ul-li::before {
    content: ""; /* 需要这个属性以便能设置伪元素的样式 */
    width: 6px; /* 调整点的大小 */
    height: 6px;
    margin-right: 6px; /* 点和文本之间的间距 */
    background-color: #19be6b; /* 修改点的颜色 */
    border-radius: 50%; /* 使点成为圆形 */
}
.content-left-ul-li:hover{
	background: #fff;
	color: #19be6b;
}
.content-left-ul-li-active{
	background: #fff;
	color: #19be6b;
}
.content-html{
	width: 90%;
	height: auto;
	box-sizing: border-box;
	padding: 42px 5%;
}
.do-content{
	width: 100%;
	height: 36px;
	display: flex;
	align-items: center;
	justify-content: flex-end;
	position: absolute;
	left: 0;
	top: 0;
	z-index: 2;
	background: #f1f1f1;
}
</style>


// WEBPACK FOOTER //
// src/views/child/Mysql.vue